import React from 'react';
import PropTypes from 'prop-types';

import Align from '@marvelapp/marvel-ui/align';
import Heading from '@marvelapp/marvel-ui/heading';
import MaxWidth from '@marvelapp/marvel-ui/max-width';
import Paragraph from '@marvelapp/marvel-ui/paragraph';
import Spacing from '@marvelapp/marvel-ui/spacing';

import ArrowButton from 'marketing-website/components/commons/ArrowButton';
import Card from 'marketing-website/components/modules/Card';
import Image from 'marketing-website/components/modules/Image';
import SmartLink from 'marketing-website/components/modules/SmartLink';

import propTypeEmptyString from '../../utils/customPropTypesCheck';

export default function ContactCard({ title, copy, url, image }) {
  return (
    <Card>
      <Align type="center">
        <Spacing type="margin" size="l" position="topBottom">
          <Image {...image} maxWidth={144} hasShadow={false} />
        </Spacing>
        <Spacing type="margin" size="xs" position="bottom">
          <Heading weight="semibold" size="xl">
            {title}
          </Heading>
        </Spacing>
        <MaxWidth value={240}>
          <Paragraph size="m" color="slate">
            {copy}
          </Paragraph>
        </MaxWidth>
        <Spacing type="padding" size="m" position="topBottom">
          <SmartLink url={url}>
            <ArrowButton />
          </SmartLink>
        </Spacing>
      </Align>
    </Card>
  );
}

ContactCard.propTypes = {
  copy: propTypeEmptyString,
  image: PropTypes.object,
  title: propTypeEmptyString,
  url: propTypeEmptyString,
  isExternal: PropTypes.bool,
};

ContactCard.defaultProps = {
  isExternal: false,
};



// WEBPACK FOOTER //
// ./src/pages/contact-us/ContactCard.js